<ds-modal
  class="modal-container"
  headerIcon="sparkles"
  [modal]="modal"
  [title]="'ai_chat' | translate"
  [colorVariant]="DsModalColorVariant.Default"
  [headerIconColor]="DsColors.Primary"
  [titleHeadingStyle]="HeadingStyle"
>
  <div class="chat-content" [class.has-messages]="messages.length > 0">
    <!-- Clear Chat Confirmation Content -->
    @if (showClearConfirmation) {
      <div class="clear-chat px-4">
        <div class="py-4">
          <button
            ds-button
            [variant]="DsButtonVariants.microAction"
            [microActionIcon]="Icons.ChevronLeft"
            (click)="cancelClearChat()"
            
          >
            {{ 'back_to_chat' | translate }}
          </button>
        </div>
        <div class="pb-4">
          <h4 class="pb-3">{{ 'clear_chat_question' | translate }}</h4>
          <span>{{ 'clear_chat_confirmation_message' | translate }}</span>
        </div>
        <div class="d-flex gap-3">
          <button
            ds-button
            [variant]="DsButtonVariants.primary"
            (click)="confirmClearChat()"
            
          >
            {{ 'clear_chat' | translate }}
          </button>
          <button
            ds-button
            [variant]="DsButtonVariants.secondary"
            (click)="cancelClearChat()"
            
          >
            {{ 'form_cancel' | translate }}
          </button>
        </div>
      </div>
    }

    <!-- Normal Chat Content -->
    @if (!showClearConfirmation) {
      <div class="messages-container" tabindex="0">
        @if (isNewSession || this.messages.length === 0) {
          <div class="ai" id="ai-chat-starter">
            <ng-container>
              <div class="label mb-2">{{ 'level_access' | translate }}</div>
              <app-ai-chat-markdown-view [value]="'ai_chat_description' | translate"></app-ai-chat-markdown-view>
              <app-ai-chat-sample-questions
                count="3"
                (questionSelected)="handleSampleQuestionClick($event)"
              ></app-ai-chat-sample-questions>
            </ng-container>
          </div>
        }

        @if (pendingUserMessage) {
          <div id="pending-message" class="d-flex flex-column gap-3 mb-2">
            <div class="user mb-2">
              <div class="label mb-2">{{ userName }}</div>
              <div class="user-message">{{ pendingUserMessage }}</div>
            </div>
            <div class="ai" [ngClass]="IChatMessageStatus.pending">
              <div class="label mb-2">{{ 'level_access' | translate }}</div>
              <div class="d-flex">
                <app-ai-chat-markdown-view [value]="'ai_response_loading' | translate"></app-ai-chat-markdown-view>
                <span class="loading-dots"></span>
              </div>
            </div>
          </div>
        }

        <div *ngFor="let message of messages; let index = index" class="d-flex flex-column gap-3 mb-2">
          <div class="user mb-2" id="user-query-{{ message._id }}">
            <div class="label mb-2">{{ userName }}</div>
            <div class="user-message">{{ message.message }}</div>
          </div>
          <div class="ai" id="ai-response-{{ message._id }}" [ngClass]="message.status" [ngSwitch]="message.status">
            <ng-container *ngSwitchCase="IChatMessageStatus.error">
              <div class="d-flex gap-3">
                <div><ds-icon [icon]="Icons.CircleExclamation"></ds-icon></div>
                <div>
                  <div>{{ message.error | translate }}</div>
                  <button class="ps-0 btn btn-link" (click)="retry(message.message, index)">
                    {{ 'retry_label' | translate }}
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="label mb-2">{{ 'level_access' | translate }}</div>
              <app-ai-chat-markdown-view [value]="message.response"></app-ai-chat-markdown-view>
              <div class="ai-rating-buttons d-flex justify-content-end mt-3">
                <ds-checkboxes-feedback
                  *featureFlag="'!' + FeatureFlagCollection.aiChat"
                  [value]="message.rating"
                  (valueChange)="onRatingChange(message, $event)"
                  [title]="ratingTitle"
                  [options]="ratingOptions"
                ></ds-checkboxes-feedback>
                <ds-star-rating
                  *featureFlag="FeatureFlagCollection.aiChat"
                  [ngModelOptions]="{ standalone: true }"
                  [ngModel]="message.rating"
                  (ngModelChange)="onRatingChange(message, $event)"
                >
                </ds-star-rating>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ds-modal-slide-out-footer class="w-100 px-2">
        <form class="chat-form d-flex flex-column mt-auto mt-auto" [formGroup]="form" (ngSubmit)="sendMessage()">
          <app-common-textarea
            class="mb-3"
            (keydown.enter)="handleEnter($event)"
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            [context]="textAreaContext"
          >
          </app-common-textarea>
          <div class="d-flex justify-content-between align-items-center p-1">
            <button
              ds-button
              [disabled]="pendingUserMessage || !sendMessageSubscription.closed"
              [variant]="DsButtonVariants.primary"
              
            >
              {{ 'action_send' | translate }}
            </button>
            <button
              ds-button
              [disabled]="pendingUserMessage"
              [variant]="DsButtonVariants.microAction"
              [microActionIcon]="Icons.TrashCan"
              [attr.aria-label]="'clear_chat' | translate"
              [attr.title]="'clear_chat' | translate"
              (click)="clearChat()"
              
              tabindex="0"
              type="button"
            >
              {{ 'clear_chat' | translate }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>
</ds-modal>
